import React from 'react'
import {
  Form, Input, Select
} from 'antd'
import { withTranslation } from 'react-i18next';

const Option = Select.Option;

const RoleForm=Form.create({
  name:'role_form',
  // onFieldsChange(props, changedFields) {
  //   let obj={};
  //   Object.values(changedFields).forEach(item=>{
  //     obj[item.name]=item.value
  //   })
  //   props.onChange(obj);
  // },
  // mapPropsToFields(props){
  //   return {
  //     name: Form.createFormField({value:props.role.name}),
  //     menuIds: Form.createFormField({value:props.role.menuIds})
  //   }
  // }
})(
  class RoleFormClass extends React.Component{
    handleChange = (val)=>{
      //传值给父组件，执行方法     
      this.props.onChange(val,'menu')
    }    
    handleRoleChange = (val)=>{
      //传值给父组件，执行方法     
      this.props.onChange(val,'sub')
    } 

    render(){
      const { t,form,allRole}=this.props     
      const {name,menuIds,subRoleIds}=this.props.role
      console.log(subRoleIds,'subRoleIds');
      const { getFieldDecorator } = form
      const formItemLayout = {
        labelCol: {
          xs: { span: 5 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 19 },
          sm: { span: 19 },
        },
      }
      return (
        <Form layout="vertical" {...formItemLayout}>
          <Form.Item label={t('Role')}>
            {getFieldDecorator('name',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:name
            })(
              <Input></Input>
            )}
          </Form.Item>
          <Form.Item label={t('Accessible Menus')}>
            {getFieldDecorator('menuIds',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:menuIds
            })(
              <Select mode="multiple" onChange={this.handleChange}>
                {
                  this.props.menus.map((menu)=>(
                    <Option value={menu.id} key={menu.id}>{menu.name}</Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
          <Form.Item label={t('sub role')}>
            {getFieldDecorator('subRoleIds',{              
              initialValue:subRoleIds
            })(
              <Select  mode="multiple" onChange={this.handleRoleChange}>
                {
                  allRole.map((role)=>(
                    <Option value={role.id} key={role.id}>{role.name}</Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>

        </Form>
      )
    }
  }
)

export default withTranslation()(RoleForm)